import unionBy from 'lodash/unionBy';
import { createRequestActionTypes } from 'common/utils/actionTypesHelper';
import { requestReducer } from 'common/utils/generators';

export const physicianActionTypes = createRequestActionTypes(
  ['getList', 'getOne', 'update', 'updateMany', 'updateStatus', 'create'],
  'physicians'
);

const initialState = {
  loading: false,
  data: [],
  total: 0,
  error: false,
};

export default requestReducer(
  [
    physicianActionTypes.getList,
    physicianActionTypes.getOne,
    physicianActionTypes.update,
  ],
  initialState,
  (payload, state) => {
    const { data, total } = payload;
    return {
      ...state,
      loading: false,
      data: Array.isArray(data) ? data : unionBy([data], state.data, 'id'),
      total,
    };
  }
);

export const getPhysicianList = (payload) => ({
  type: physicianActionTypes.getList.requested,
  payload,
});

export const getPhysician = ({ id }) => ({
  type: physicianActionTypes.getOne.requested,
  payload: { id },
});

export const updatePhysician = (payload, onSuccess, onError) => ({
  type: physicianActionTypes.update.requested,
  payload,
  onSuccess,
  onError,
});

export const updatePhysicians = (payload, onSuccess, onError) => ({
  type: physicianActionTypes.updateMany.requested,
  payload,
  onSuccess,
  onError,
});

export const updatePhysicianStatus = (
  payload,
  onSuccess,
  onError = () => null
) => ({
  type: physicianActionTypes.updateStatus.requested,
  payload,
  onSuccess,
  onError,
});

export const createPhysician = (payload, onSuccess, onError) => ({
  type: physicianActionTypes.create.requested,
  payload,
  onSuccess,
  onError,
});
